import { useEffect, ReactNode } from 'react';
import { THEME_LOCAL_STORAGE_KEY } from '../../constants/local-storage';
import useLocalStorage from '../../hooks/use-local-storage';
import { CURRENT_INSTANCE, CURRENT_TENANT } from '../../tenant';
import ThemeProviderContext from '../contexts/theme-context';

interface IThemeProviderProps {
  children: ReactNode;
}

function applyThemeTokens() {
  const root = window.document.documentElement;
  const tokens = CURRENT_INSTANCE.theme.tokens;
  root.style.setProperty('--xircle-main', tokens.main);
  root.style.setProperty('--xircle-secondary', tokens.secondary);
  root.style.setProperty('--xircle-main-soft', tokens.soft);
  if (tokens.textOnSecondary) {
    root.style.setProperty('--xircle-text-on-secondary', tokens.textOnSecondary);
    root.style.setProperty('--hexal-dark-text-color', tokens.textOnSecondary);
  }
  if (tokens.textOnMain) {
    root.style.setProperty('--xircle-text-on-main', tokens.textOnMain);
  }
  if (tokens.background) {
    root.style.setProperty('--xircle-background', tokens.background);
  }
  root.setAttribute('data-tenant', CURRENT_TENANT.id);
  root.setAttribute('data-instance', CURRENT_INSTANCE.id);
  root.classList.add(CURRENT_INSTANCE.themeName);
}

function ThemeProvider({ children, ...props }: IThemeProviderProps) {
  const [themeName] = useLocalStorage<string>(
    `${THEME_LOCAL_STORAGE_KEY}_${CURRENT_INSTANCE.id}`,
    CURRENT_INSTANCE.themeName
  );

  useEffect(() => {
    applyThemeTokens();
  }, [themeName]);

  const value = {
    themeName,
  };

  return (
    <ThemeProviderContext.Provider {...props} value={value}>
      {children}
    </ThemeProviderContext.Provider>
  );
}

export default ThemeProvider;
